export const API_KEY = 'c4f79a656174a40d7584098be8efeb0e'
export const TMDB_BASE_URL = 'https://api.themoviedb.org/'